<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">
                        {{ this.parentObject.pageTitle }}
                        <span class="page_title_value">{{ this.parentObject.pageTitleValue }}</span>
                    </h2>
                </v-row>

                <v-container id="scroll-target" class="custom-form overflow-y-auto px-5">
                    <v-row>
                        <v-col cols="12" sm="10" class="pb-n4">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.description')"
                                type="text"
                                v-model="formData.description"
                                :rules="[rules.required]"
                                :error-messages="descriptionError"
                                @input="onDescriptionInput"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('attendanceincentivesetup.selectallowance')"
                                type="text"
                                v-model="formData.payitemid"
                                hide-selected
                                :items="allowanceList"
                                :rules="[rules.required]"
                                @change="changeAllowanceHandler(formData.payitemid)"
                                background-color="white"
                                dense
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                background-color="#ffeab2"
                                readonly
                                :label="this.$t('attendanceincentivesetup.payitemcode')"
                                type="text"
                                v-model="payitemcode"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4" sm="5" class="pb-n5 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.startdate')"
                                type="date"
                                ref="startdate"
                                v-model="formData.startdate"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" sm="5" class="pb-n5 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.enddate')"
                                type="date"
                                ref="enddate"
                                v-model="formData.enddate"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="10" class="pb-n5 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.remark')"
                                type="text"
                                v-model="formData.remark"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="6" class="pb-n5 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('attendanceincentivesetup.incentivecategory')"
                                type="text"
                                v-model="formData.categoryid"
                                :items="categoryList"
                                :rules="[rules.required]"
                                @change="updateValue"
                                dense
                            ></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="12">
                            <h3 class="pb-2">{{ $t('attendanceincentivesetup.parameter') }}</h3>
                            <app-conditions-table
                                v-bind:parentObject="{
                                    tabHeader: this.conditionsTabHeader,
                                    eligibleGroupsTabHeader: this.eligibleGroupsTabHeader,
                                    detailItem: this.formData.incentivedetail
                                }"
                                v-on:input="addConditionHandler"
                            />
                        </v-col>
                    </v-row>
                </v-container>

                <app-formbuttons
                    v-bind:EditBool="this.parentObject.isEdit"
                    v-on:NewPressed="newHandler"
                    v-on:SavePressed="saveHandler"
                    v-on:DeletePressed="deleteHandler"
                    v-on:CancelPressed="cancelHandler"
                />
            </v-form>
        </v-container>
    </div>
</template>

<script>
import CRUDTable from './CRUDTable';
import FormButtons from '../../common/FormButtons';

export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-conditions-table': CRUDTable,
        'app-formbuttons': FormButtons,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },
            formData: {
                id: this.parentObject.data.id,
                description: this.parentObject.data.description,
                payitemid: this.parentObject.data.payitemid,
                payitemcode: this.parentObject.data.payitemcode,
                payitemdesc: this.parentObject.data.payitemdesc,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                remark: this.parentObject.data.remark,
                categoryid: this.parentObject.data.categoryid,
                incentivedetail: this.parentObject.data.incentivedetail,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid,
            },
            descriptionError: '',
            categoryList: [],
            categoryItems: [],
            conditionsTabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '140px', sortable: false },
                { text: this.$t('attendanceincentivesetup.daytype'), value: 'daytypecodes', width: '200px', sortable: false },
                { text: this.$t('attendanceincentivesetup.shift'), value: 'shiftcodes', width: '250px', sortable: false },
                { text: this.$t('setupforshift.mustfulfillshifthours'), value: 'mustfulfillshifthours', width: '200px', sortable: false },
                { text: this.$t('setupforshift.minumumothours'), value: 'minothours', width: '150px', sortable: false },
            ],
            eligibleGroupsTabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false },
                { text: this.$t('attendanceincentivesetup.workgroup'), value: 'workgroupcodes', width: '200px', sortable: false },
                { text: this.$t('columns.company'), value: 'companycodes', width: '200px', sortable: false },
                { text: this.$t('columns.branch'), value: 'branchcodes', width: '200px', sortable: false },
                { text: this.$t('columns.department'), value: 'deptcodes', width: '200px', sortable: false },
                { text: this.$t('columns.division'), value: 'divisioncodes', width: '200px', sortable: false },
                { text: this.$t('columns.section'), value: 'sectioncodes', width: '200px', sortable: false },
                { text: this.$t('columns.unit'), value: 'unitcodes', width: '200px', sortable: false },
                { text: this.$t('columns.employmenttype'), value: 'emptypecodes', width: '200px', sortable: false },
                { text: this.$t('columns.grade'), value: 'gradecodes', width: '200px', sortable: false },
                { text: this.$t('columns.job'), value: 'jobcodes', width: '200px', sortable: false },
                { text: this.$t('columns.position'), value: 'positioncodes', width: '200px', sortable: false },
            ],
            allowanceList: [],
            allowanceItems: [],
            payitemcode: '',
        }
    },

    methods: {
        addConditionHandler($event) {
            this.formData.incentivedetail = $event;
            this.updateValue();
        },

        onDescriptionInput() {
            this.descriptionError = '';
            this.updateValue();
        },

        setDescriptionError(msg) {
            this.descriptionError = msg;
        },

        loadCategory() {
            const vm = this;
            this.$store.dispatch('get', { url: '/attninctcategory/all' })
                .then(res => {
                    vm.categoryItems = res.data.rec;
                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.categoryList.push({
                            text: res.data.rec[i].categorydesc,
                            value: res.data.rec[i].id,
                        });
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },

        loadAllowances() {
            const vm = this;
            this.$store.dispatch('get', { url: '/shiftallowance/all' })
                .then(res => {
                    vm.allowanceItems = res.data.rec;
                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.allowanceList.push({
                            text: res.data.rec[i].payitemdesc,
                            value: res.data.rec[i].id,
                        });
                    }
                    if (this.formData.payitemid) {
                        this.changeAllowanceHandler(this.formData.payitemid);
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },

        changeAllowanceHandler(id) {
            let item = this.allowanceItems.find(item => item.id === id);
            if (item) {
                this.payitemcode = item.payitemcode;
                this.formData.payitemcode = item.payitemcode;
                this.formData.payitemdesc = item.payitemdesc;
            }
            this.updateValue();
        },

        updateValue() {
            this.$emit('input', {
                id: this.formData.id,
                description: this.formData.description,
                payitemid: this.formData.payitemid,
                payitemcode: this.formData.payitemcode,
                payitemdesc: this.formData.payitemdesc,
                startdate: this.formData.startdate,
                enddate: this.formData.enddate,
                remark: this.formData.remark,
                categoryid: this.formData.categoryid,
                incentivedetail: this.formData.incentivedetail,
                stamp: this.formData.stamp,
                userid: this.formData.userid,
            });
        },

        newHandler() {
            this.$emit('new');
        },

        saveHandler() {
            this.updateValue();
            this.$emit('save');
        },

        deleteHandler() {
            this.$emit('delete');
        },

        cancelHandler() {
            this.$router.push({ name: 'attndincsetuplist' });
        },
    },

    mounted() {
        this.loadAllowances();
        this.loadCategory();
    }
}
</script>
